
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/console",
      function () {
        return require("private-next-pages/console/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/console"])
      });
    }
  